import styled from "styled-components";

import { theme } from '../../configuration';

const HelpResultHeading = styled.div`
  color: ${theme.colours.main};
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  font-size: 0.9em;
  padding: 7px 0px 7px 3px;
  text-align: center;
  text-transform: uppercase;
`;

export default HelpResultHeading;
